<template>
  <div>
    <a-select
      show-search
      allowClear
      :required="true"
      :disabled="isDisabled"
      :filter-option="filterOption"
      :placeholder="$t(`form.pleaseChoose`) + $t(`form.supplierName`)"
      style="width: 100%"
      v-model="index"
      @change="supplierIndexChange"
    >
      <a-select-option
        :key="item.supplierCode"
        :value="index"
        v-for="(item, index) in supplierList"
      >
        {{ item.supplierName }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'
export default {
  name: 'selectSupplier',
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    code: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      supplierList: [],
      index: undefined,
    }
  },
  created() {
    this.queryOrderList()
  },
  watch: {
    code: {
      handler() {
        this.getDefault()
      },
      immediate: true,
    },
  },
  methods: {
    clear() {
      this.index = undefined
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    getDefault() {
      if (this.supplierList.length === 0) return
      let index = this.supplierList.findIndex((item) => item.supplierCode === this.code)
      if (index > -1) {
        this.supplierIndexChange(index)
        this.index = index
      }
    },
    supplierIndexChange(val) {
      let data = this.supplierList[val] || {}
      let formData = {
        ...data,
        supplierAddress: data.fullAddress,
        supplierMobile: data.mobile,
        openingBank: data.bankName,
      }
      this.$emit('supplierIndexChange', formData)
    },
    queryOrderList() {
      this.$nextTick(() => {
        let data = {
          status: 1,
        }
        http({
          type: 'post',
          url: api.queryPurchaseSupplierList,
          hasLoading: true,
          data,
          success: (res) => {
            this.supplierList = res.result
            this.getDefault()
          },
        })
      })
    },
  },
}
</script>

<style lang="less" scoped></style>
